import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRight, X } from '@phosphor-icons/react';
import { BACKEND_URL } from '../config';

/**
 * Global banner shown at the top of the app when business profile is incomplete.
 * Includes percentage indicator.
 */
export default function SetupBanner() {
  const navigate = useNavigate();
  const [completion, setCompletion] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const sessionDismissed = sessionStorage.getItem('mm_setup_banner_dismissed');
    if (sessionDismissed) {
      setDismissed(true);
      return;
    }

    (async () => {
      try {
        const res = await fetch(`${BACKEND_URL}/api/service-os/profile/completion`, {
          credentials: 'include',
        });
        if (res.ok) {
          const data = await res.json();
          setCompletion(data);
        }
      } catch {}
    })();
  }, []);

  if (dismissed || !completion || completion.status === 'completed') return null;

  const handleDismiss = () => {
    setDismissed(true);
    sessionStorage.setItem('mm_setup_banner_dismissed', 'true');
  };

  return (
    <div
      className="bg-[rgba(99,102,241,0.08)] border-b border-[rgba(99,102,241,0.15)] px-4 py-2.5 flex items-center justify-between"
      data-testid="setup-banner"
    >
      <div className="flex items-center gap-3">
        {/* Progress indicator */}
        <div className="flex items-center gap-1.5">
          <div className="w-16 h-1.5 bg-[rgba(255,255,255,0.06)] rounded-full overflow-hidden">
            <div
              className="h-full bg-[#6366F1] rounded-full transition-all"
              style={{ width: `${completion.percentage}%` }}
            />
          </div>
          <span className="text-[10px] text-[#818CF8] font-medium">{completion.percentage}%</span>
        </div>

        <span className="text-xs text-[#C8D1DC]">
          Finish your business setup to unlock full automation
        </span>

        <button
          onClick={() => navigate('/business-setup')}
          data-testid="setup-banner-cta"
          className="flex items-center gap-1 text-xs font-semibold text-[#818CF8] hover:text-[#A5B4FC] transition-colors"
        >
          Complete Setup <ArrowRight size={12} />
        </button>
      </div>

      <button
        onClick={handleDismiss}
        className="text-[#4B5563] hover:text-white transition-colors ml-2"
        data-testid="setup-banner-dismiss"
      >
        <X size={14} />
      </button>
    </div>
  );
}
